export default {
  common: {
    loading: "Loading...",
    error: "Error",
    success: "Success",
    save: "Save",
    cancel: "Cancel",
    clear: "Clear",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    back: "Back",
    next: "Next",
    search: "Search",
    filter: "Filter",
    sort: "Sort",
    noResults: "No results found",
    submit: "Submit",
    name: "Name",
    email: "Email",
    phone: "Phone",
    amount: "Amount",
    comment: "Comment",
    photo: "Photo",
    upload: "Upload",
    takePhoto: "Take or upload photo",
    retry: "Try Again",
    placeholder: {
      name: "Your name",
      email: "Your email",
      orderId: "#ID",
      comment: "Comment",
      deleteReason: "Please tell us the reason for your deletion request...",
      featureSuggestion: "Tell us more about your feature suggestion...",
    },
    noItemsFound: "No items found",
    merchantAppName: "Mezza Merchant",
    fileTypes: "jpg, jpeg, png, gif, pdf, doc, docx, xls, xlsx, txt, webp",
    emptyState: {
      title: "No items found",
      description: "No items found",
    },
    comingSoon: "Coming Soon",
    test: "Test",
  },
  datePicker: {
    pickDatePlaceholder: "Pick a date",
  },
  auth: {
    signIn: "Sign In",
    signOut: "Sign Out",
    email: "Email",
    password: "Password",
    or: "OR",
    forgotPassword: "Forgot Password?",
    forgotPasswordDescription: "Enter your email address and we'll send you a link to reset your password.",
    resetPassword: "Reset Password",
    confirmPassword: "Confirm Password",
    createAccount: "Create Account",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    signOutSuccess: "Successfully signed out",
    signOutError: "Failed to sign out",
    signOutConfirmTitle: "Sign out?",
    signOutConfirmDescription:
      "You will need to sign in again to access the merchant dashboard.",
    signingIn: "Signing in...",
    signingInSuccess: "Successfully signed in",
    signingInError: "Sign in failed. Please check your email and password and try again.",
    signInError: "Sign in failed. Please check your email and password and try again.",
    loginWithOtp: "Login with verification code",
    loginWithPassword: "Login with password",
    sendVerificationCode: "Send verification code",
    sendResetLink: "Send Reset Link",
    enterEmail: "Enter your email address",
    verificationCodeSent: "Verification code sent to {{email}}",
    enterVerificationCode: "Enter the 6-digit code",
    resendIn: "Resend code in",
    resendCode: "Resend code",
    invalidCode: "Invalid verification code",
    codeSentSuccess: "Verification code sent successfully",
    codeResendSuccess: "Verification code resent",
    passwordResetEmailSent: "Password reset email sent",
    passwordResetEmailSentDescription: "Please check your email for instructions to reset your password. If you don't see it, check your spam folder.",
    passwordResetEmailError: "Failed to send password reset email. Please try again.",
    backToLogin: "Back to Login",
  },
  navigation: {
    dashboard: "Dashboard",
    orders: "Orders",
    customers: "Customers",
    reports: "Reports",
    settings: "Settings",
    support: "Help & Support",
    profile: "Profile",
    menu: "Menu",
    logout: "Logout",
    policies: "Policies & Agreements",
  },
  orders: {
    title: "Recent Orders",
    newOrder: "New Order",
    orderType: "Order Type",
    amount: "Amount",
    date: "Date",
    status: "Status",
    customer: "Customer",
    reference: "Reference",
    notes: "Notes",
    orderId: "Order ID",
    types: {
      closeBill: "Close a Bill",
      refund: "Refund Amount",
      eventDeposit: "Charge Event Payment - Deposit",
      eventFinal: "Charge Event Payment - Final",
    },
    statuses: {
      completed: "Completed",
      pending: "Pending",
      failed: "Failed",
      refunded: "Refunded",
    },
    location: "Location",
    billAmount: "Bill Amount",
    ticketNumber: "Ticket/Check Number",
    checkNumber: "Check",
    posPaymentPosted: "Posted to Toast",
    posPaymentUnverified: "Toast post unverified",
    priorPayments: "Prior Payments",
    applyMezzaCash: "Apply Mezza Cash",
    partialPayments: "Partial Payments",
    recordTips: "Record Tips",
    viewHistory: "View Order History",
    processRefund: "Process Refund",
    tip: "Tip",
    bill: "Bill",
    emptyState: {
      title: "You don't have any orders yet",
    },
    calculator: {
      ordersSelected: "{{count}} order selected_other",
      ordersSelected_one: "{{count}} order selected",
      ordersSelected_other: "{{count}} orders selected",
      total: "Total",
      bill: "Bill",
      tip: "Tip",
      cancel: "Cancel",
      noOrders: "No orders selected",
    },
  },
  members: {
    title: "Members",
    newMember: "New Member",
    name: "Name",
    email: "Email",
    phone: "Phone",
    balance: "Balance",
    lastVisit: "Last Visit",
    totalSpent: "Total Spent",
    searchPlaceholder: "Search by name, email, or phone...",
    searchProfiles: "Search Customer Profiles",
    guestProfile: "Guest Profile",
    selectMemberToCharge: "Select Member",
    emptyState: {
      title: "No members found",
    },
  },
  customers: {
    title: "Customers",
    newCustomer: "New Customer",
    name: "Name",
    email: "Email",
    phone: "Phone",
    balance: "Balance",
    lastVisit: "Last Visit",
    totalSpent: "Total Spent",
    searchPlaceholder: "Search by name, email, or phone...",
    searchProfiles: "Search Customer Profiles",
    memberProfile: "Member Profile",
    totalVisits: "Total visits: {{count}}",
    lastVisitDate: "Last visit: {{date}}",
    lifetimeSpend: "Lifetime Spend",
    lifetimeTip: "Lifetime Tip",
    recentOrders: "Recent Orders",
    noMemberFound: "No member found",
    memberLoadError: "Failed to load member details",
  },
  reports: {
    title: "Reports",
    dateRange: "Date Range",
    export: "Export",
    revenue: "Revenue",
    orders: "Orders",
    customers: "Customers",
    averageOrder: "Average Order Value",
    topItems: "Top Items",
    categories: "Categories",
    endOfDay: "End of Day Reports",
  },
  settings: {
    title: "Settings",
    profile: "Profile",
    notifications: "Notifications",
    security: "Security",
    language: "Language",
    theme: "Theme",
    business: {
      title: "Business Settings",
      name: "Business Name",
      address: "Address",
      phone: "Phone",
      email: "Email",
      hours: "Business Hours",
    },
  },
  support: {
    title: "Support",
    contact: "Contact Support",
    faq: "FAQ",
    documentation: "Documentation",
    reportIssue: "Report an Issue",
    deleteRequest: "Delete Account Request",
    suggestFeature: "Suggest a Feature",
    locations: "Locations",
    validation: {
      locationsRequired: "At least one location is required",
    },
    emailSupport: "Email Support",
    callSupport: "Call Support",
    posTraining: "Point of Sale Training",
    posQuickReference: "Point of Sale Quick Reference",
    commonQuestions: "Common Questions",
    trainingSteps: "Training Steps",
    quickReferenceGuide: "Quick Reference Guide",
    troubleshooting: "Troubleshooting",
    processingOrders: "Processing Orders",
    refunds: "Refunds",
    trainingVideo: "Training Video",
    reportIssueSuccess: "An email with the provided information has been sent",
    deleteRequestSuccess: "Your delete request has been submitted and will be handled within 5 business days",
    steps: {
      introduction: "Step 1: Introduction to POS",
      basicOperations: "Step 2: Basic Operations",
      advancedFeatures: "Step 3: Advanced Features",
    },
    help: {
      description:
        "If you're experiencing any issues, please reach out immediately. Select one:",
      emailSupport: "Email {{email}}",
      emailSupportTooltip: "Email {{email}}",
      callSupport: "Call Support: {{phone}}",
      callSupportTooltip: "Call Support: {{phone}}",
    },
    resources: {
      title: "Knowledge Center",
      description: "Learn more about Mezza and how to use it.",
      systemOverview: "System overview",
      basicNavigation: "Basic navigation",
      userInterface: "User interface elements",
      processingTransactions: "Processing transactions",
      handlingRefunds: "Handling refunds",
      managingInventory: "Managing inventory",
      reportingTools: "Reporting tools",
      analyticsDashboard: "Analytics dashboard",
      customerManagement: "Customer management",
      quickReference: {
        scanItems: "Scan items or enter manually",
        applyDiscounts: "Apply discounts if needed",
        selectPayment: "Select payment method",
        completeTransaction: "Complete transaction",
        locateTransaction: "Locate original transaction",
        selectItems: "Select items to refund",
        chooseMethod: "Choose refund method",
        processRefund: "Process refund",
        generateSummary: "Generate daily summary",
        reviewTransactions: "Review transactions",
        exportReports: "Export reports",
        closeRegister: "Close register",
        checkConnection: "Check internet connection",
        restartPos: "Restart POS if needed",
        contactSupport: "Contact support for issues",
      },
    },
  },
  errors: {
    unknown: "An unknown error occurred",
    generic: "An error occurred. Please try again.",
    required: "This field is required",
    invalidEmail: "Please enter a valid email address",
    invalidPhone: "Please enter a valid phone number",
    passwordMismatch: "Passwords do not match",
    networkError: "Network error occurred",
    serverError: "Server error occurred",
    unauthorized: "Unauthorized access",
    cameraPermissionDenied: "Camera access was denied. Please enable camera permission in your device settings and try again.",
    fileSize: "File size must be less than 10MB",
    maxLength: "Maximum length is {{count}} characters",
    unauthorizedPage: "You are not authorized to access this page",
    offline: "No internet connection. Please check your network and try again.",
    notFound: "The requested resource was not found",
    forbidden: "Access forbidden",
    serverUnavailable: "A server error occurred. Please try again later",
    validationError: "The data received was invalid. Please try again or contact support if the issue persists.",
  },
  success: {
    saved: "Successfully saved",
    deleted: "Successfully deleted",
    updated: "Successfully updated",
    created: "Successfully created",
    passwordReset: "Password reset email sent",
  },
  validation: {
    minLength: "Minimum length is {{count}} characters",
    maxLength: "Maximum length is {{count}} characters",
    minValue: "Minimum value is {{count}}",
    maxValue: "Maximum value is {{count}}",
  },
  accessibility: {
    closeMenu: "Close menu",
    openMenu: "Open menu",
    closeSheet: "Close sheet",
    mobileNavigationDescription: "Mobile navigation menu with user profile and navigation links",
  },
  dashboard: {
    layout: {
      navigationLabel: "Dashboard navigation",
      accountMenuLabel: "Account menu",
      signedInAs: "Signed in as",
      collapseMenu: "Collapse menu",
      expandMenu: "Expand menu",
    },
    navigation: {
      overview: "Overview",
      websiteLeads: "Website Leads",
      funding: "Funding",
      guestFlow: "Guest Flow",
      reports: "Reports",
      merchantApp: "Merchant app",
    },
    reports: {
      title: "Reports",
      description: "Download your Mezza reports, or have them emailed.",
      emptyTitle: "No reports enabled",
      empty: "No reports are available for your account. Contact your Mezza account manager if you need one.",
      emptyHint: "Your Mezza team can turn on Orders, Tips, or Statement of Account from the merchant dashboard settings in Hub.",
      previewNote: "Downloads and emails are turned off in the preview.",
      preview: {
        label: "Export preview",
        formatCsv: "CSV",
        formatPdf: "PDF",
      },
      reportType: "Choose a report",
      actionsHintCsv: "Download saves a CSV to your device. Email sends the same file to the addresses above.",
      actionsHintStatement: "Download PDF or Excel, or email both formats to the addresses above.",
      sections: {
        scope: "Locations",
        period: "Date range",
        delivery: "Email recipients",
      },
      locationsHint: "Leave empty to include all your locations.",
      recipientsHint: "Only needed for email. Up to {{maxEmails}} addresses.",
      addMe: "Add me",
      downloadCsv: "Download CSV",
      downloadPdf: "Download PDF",
      downloadExcel: "Download Excel",
      email: "Email",
      downloaded: "Your report has been downloaded.",
      emailed: "Your report has been emailed.",
      statementQueued: "Your Statement of Account will be emailed shortly.",
      noData: "There is no data for the selected locations and dates.",
      failed: "The report could not be generated. Please try again.",
      orders: {
        title: "Orders report",
        description: "Every payment made through Mezza, one row per payment, as a CSV.",
      },
      tips: {
        title: "Tips report",
        description: "Tips and processing fees for every payment made through Mezza, as a CSV.",
      },
      statementOfAccount: {
        title: "Statement of Account",
        description: "Your Mezza funding, what members redeemed and the balance remaining, as a PDF or Excel file.",
      },
    },
    guestFlow: {
      title: "Guest Flow",
      subtitle:
        "Tell us when you'd love more Mezza guests through the door. We use your plan to time member offers and nudges.",
      steps: {
        pick: {
          title: "Pick a brush",
          description: "Send more guests for your quiet times, or Erase to clear a slot.",
        },
        paint: {
          title: "Paint your week",
          description: "Click or drag across the half-hour slots. Drag again to undo.",
          descriptionTouch: "Tap a slot, or press and hold, then drag. Do it again to undo.",
        },
        result: {
          title: "We do the rest",
          description: "Our team focuses member promotions on your quiet hours.",
        },
      },
      sections: {
        summaryDescription: "A quick read-back of the hours you painted.",
        summaryHint_one: "{{count}} time block",
        summaryHint_other: "{{count}} time blocks",
        optionalTitle: "Capacity, notes & special dates",
        optionalDescription: "All optional. Add only what helps us send the right guests.",
        optionalHintCapacity: "Up to {{count}} extra guests",
        optionalHintGroups: "Groups welcome",
        optionalHintNote: "Note added",
        optionalHintDates_one: "{{count}} special date",
        optionalHintDates_other: "{{count}} special dates",
      },
      loadFailed: "Could not load your guest flow plan.",
      noLocations: "You don't have any locations yet.",
      localTime: "All times are your venue's local time",
      localTimeWithZone: "All times are your venue's local time ({{zone}})",
      lastUpdated: "Updated by {{name}} on {{date}}",
      hoursPerWeek_one: "{{count}} h / week",
      hoursPerWeek_other: "{{count}} h / week",
      readOnly: "Only managers can change this plan. You can still see what Mezza has on file.",
      intent: {
        boost: "Send more guests",
        hold: "Hold off",
        none: "No preference",
      },
      brush: {
        label: "What to paint",
        boost: "Send more guests",
        hold: "Hold off",
        erase: "Erase",
      },
      presets: {
        label: "Quick start",
        weekdayLunch: "Weekday lunches",
        afternoonLull: "Afternoon lull",
        earlyWeekEvenings: "Mon–Wed evenings",
        weekendBrunch: "Weekend brunch",
        remove: "Click again to clear these hours",
        clear: "Clear all",
      },
      planner: {
        label: "Weekly plan, one row per day in half-hour slots",
      },
      closed: "closed",
      legend: {
        open: "Open",
        openAny: "Open (at least one location)",
        closed: "Closed",
      },
      showFullDay: "Show the full day",
      showOpeningHours: "Show opening hours only",
      copyDay: {
        trigger: "Copy {{day}} to other days",
        title: "Copy {{day}} to…",
        weekdays: "Weekdays (Mon–Fri)",
        weekend: "Weekend (Sat–Sun)",
        everyDay: "Every day",
      },
      summary: {
        title: "What we'll see",
        label: "Plan summary",
        empty: "Nothing painted yet. Pick a quick start or paint the times you want more guests.",
        everyDay: "Every day",
      },
      note: {
        label: "Anything else we should know? (optional)",
        placeholder: "e.g. Groups of 10+ are welcome at lunch, or the terrace opens in March.",
      },
      capacity: {
        label: "How many extra guests can you take in a boost hour? (optional)",
        placeholder: "e.g. 20",
        suffix: "guests",
        groupsWelcome: "Groups welcome",
      },
      specialDates: {
        title: "Special dates",
        description:
          "Holidays, private events or a slow week ahead? A special date replaces your weekly plan for that day only.",
        pickDate: "Pick a date",
        add: "Add date",
        duplicate: "This date is already on the list",
        empty: "No special dates. Your weekly plan applies every day.",
        label: "What's happening",
        labelPlaceholder: "e.g. Private event, National Day",
        noPreference: "No preference this day",
        remove: "Remove {{date}}",
        plannerLabel: "Plan for {{date}} in half-hour slots",
      },
      stale: {
        message_one: "This plan was last updated {{count}} day ago. Is it still right?",
        message_other: "This plan was last updated {{count}} days ago. Is it still right?",
        confirm: "Yes, still right",
      },
      unsaved: "Unsaved changes",
      allSaved: "All changes saved",
      discard: "Discard",
      save: "Save plan",
      saved: "Plan saved.",
      savedAll: "Plan saved for all locations.",
      savedLocations_one: "Plan saved for {{name}}.",
      savedLocations_other: "Plan saved for {{count}} locations.",
      discardConfirm: "You have unsaved changes. Discard them?",
      scope: {
        title: "Who is this plan for?",
        mode: {
          merchant_one: "All locations",
          merchant_other: "All {{count}} locations",
          locations: "Specific locations",
        },
        merchantDescription_one:
          "One plan for your location, including any location you add later.",
        merchantDescription_other:
          "One plan for all {{count}} locations, including any location you add later. Locations with their own plan keep it.",
        locationsDescription: "Pick one or more locations. They all get the plan you paint below.",
        locationsDescriptionWithAll:
          "Pick one or more locations to give them their own plan. It replaces the all-locations plan for them.",
        selectAll: "Select all",
        selectOne: "Clear selection",
        pickLocations: "Pick at least one location to see and edit its plan.",
        source: {
          none: "No plan yet",
          merchant: "Follows the all-locations plan",
          location: "Has its own plan",
        },
        editOwnPlan: "Edit",
        useAllPlan: "Use all-locations plan",
        removeOwnPlan: "Remove own plan",
        resetDone_one: "The location now follows the all-locations plan.",
        resetDone_other: "{{count}} locations now follow the all-locations plan.",
        allLocationsTitle_one: "All locations",
        allLocationsTitle_other: "All {{count}} locations",
        selectedTitle_one: "{{count}} location",
        selectedTitle_other: "{{count}} locations",
        merchantReadOnly:
          "Only a manager with access to every location can change the plan for all locations. You can still give your own locations their own plan.",
        followsAllNotice:
          "This location follows the all-locations plan. Saving here gives it its own plan.",
        differentPlansNotice:
          "These locations have different plans right now. Showing the plan of the first one; saving replaces all of their plans with it.",
        overwriteConfirm:
          "The {{count}} selected locations have different plans. Saving replaces all of them with this one. Continue?",
        appliesToAll_one: "Applies to your location",
        appliesToAll_other: "Applies to all {{count}} locations",
        appliesToSelected_one: "Applies to the selected location",
        appliesToSelected_other: "Applies to the {{count}} selected locations",
        saveAll: "Save for all locations",
        saveSelected_one: "Save for this location",
        saveSelected_other: "Save for {{count}} locations",
      },
      saveFailed: "Could not save the plan. Please try again.",
      errors: {
        invalidWindows: "Some time windows overlap or are not on the half-hour grid. Repaint them and try again.",
        invalidDates: "A special date is invalid, listed twice, or more than a year ahead.",
        merchantScopeForbidden:
          "Only a manager with access to every location can change the plan for all locations. Pick specific locations instead.",
        forbidden: "Only managers can change when Mezza sends guests.",
        locationNotFound: "One of the selected locations is no longer available. Refresh the page and try again.",
        validation: "The note or a special-date label has characters we can't accept, or a number is out of range.",
      },
    },
    funding: {
      title: "Funding",
      subtitle: "The funding Mezza has given your business, month by month. Need more? Send us a request.",
      requestButton: "Request funding",
      myRequestsButton: "My requests",
      requests: {
        title: "Your funding requests",
        description: "Requests you've sent to Mezza. Our team reviews each one and gets in touch with you directly.",
        empty: "You haven't sent any funding requests yet.",
        loadFailed: "Could not load your requests.",
        sentOn: "Sent on {{date}}",
        sentBy: "by {{name}}",
      },
      historyTitle: "Funding history",
      month: "Month",
      amount: "Amount",
      fundings: "Fundings",
      totalFunded: "Total funded",
      monthsFunded: "Months with funding",
      multiCurrencyHint: "Totals are listed per currency in the table below.",
      historyRowCount: "{{count}} months",
      loadFailed: "Could not load your funding history.",
      emptyTitle: "No funding yet",
      emptyDescription: "Once Mezza funds your business, each funding will appear here by month.",
      request: {
        title: "Request additional funding",
        description: "Tell us how much you need and what it's for. Our team will review your request and get in touch.",
        amount: "Amount needed",
        amountPlaceholder: "Enter the amount you would like to request",
        reason: "What is the funding for?",
        reasonPlaceholder: "Describe how you plan to use the funding",
        locations: "Locations",
        submit: "Send request",
        successTitle: "Request sent",
        successDescription: "We received your request. Our team will be in touch.",
        failed: "Could not send your request. Please try again.",
        mixedCurrencies: "The selected locations use different currencies. Pick locations with one currency.",
        validation: {
          amountRequired: "Enter the amount you need",
          amountPositive: "The amount must be greater than zero",
          amountTooLarge: "The amount is too large",
          reasonRequired: "Tell us what the funding is for",
          reasonTooLong: "Keep it under 2,000 characters",
          locationsRequired: "Select at least one location",
        },
      },
    },
    websiteLeads: {
      title: "Website Leads",
      subtitle:
        "Emails your website visitors entered in the Mezza popup. Each file includes the email, first and last name (when the guest joined Mezza) and when the email was entered.",
      zipPasswordLabel: "Password",
      statsExports: "Weekly exports",
      statsLeads: "Emails in these exports",
      weeklyListLabel: "Weekly exports",
      columns: {
        period: "Period",
        type: "Type",
        leads: "New emails",
        password: "Password",
        download: "Download",
      },
      visibleCount: "{{shown}} of {{total}} shown",
      loadingMore: "Loading more weeks…",
      endOfList: "You’ve reached the oldest export",
      customExport: "Custom export",
      customTitle: "Export a date range",
      customHint: "Pick dates or export everything since your first popup signup.",
      from: "From",
      to: "To",
      prepare: "Prepare export",
      allTime: "All time",
      types: {
        weekly: "Weekly",
        custom: "Custom",
      },
      showPassword: "Show password",
      hidePassword: "Hide password",
      copyPassword: "Copy password",
      passwordCopied: "Password copied",
      passwordCopyFailed: "Could not copy the password",
      download: "Download",
      downloadFailed: "Could not download the export. Please try again.",
      loadFailed: "Could not load website leads.",
      emptyTitle: "No website leads yet",
      emptyDescription: "When visitors enter their email in your website popup, weekly exports will appear here.",
    },
    home: {
      title: "Overview",
      subtitle: "How Mezza is growing your business: your capital, your sales and your members.",
    },
    overview: {
      activityTitle: "Activity through Mezza",
      activitySubtitle: "Compared with the previous period of the same length. Today counts up to now.",
      activitySubtitleNoComparison: "Your activity for the selected period. Today counts up to now.",
      activityLoadFailed: "Could not load your activity.",
      mixedCurrencies: "Your selected locations use different currencies. Pick locations with one currency to see these numbers.",
      period: {
        presets: {
          last7: "Last 7 days",
          last30: "Last 30 days",
          last90: "Last 90 days",
          thisMonth: "This month",
          lastMonth: "Last month",
          yearToDate: "Year to date",
          custom: "Custom range",
        },
        customTitle: "Choose a period",
        from: "From",
        to: "To",
        apply: "Apply",
        invalidOrder: "The start date must be on or before the end date.",
        tooLong: "Choose a period of one year or less.",
      },
      capital: {
        title: "Your Mezza capital",
        allTime: "All time",
        ringLabel: "redeemed",
        fundedOn: "Funded on {{date}}",
        latestFunding: "{{count}} fundings · latest on {{date}}",
        creditLine: "Credit line from Mezza",
        cashAdvanced: "Cash advanced: {{amount}}",
        redeemed: "Redeemed by members",
        remaining: "Still to redeem",
        paceBefore: "Members redeem about",
        paceAfter: "a month. At this pace, your remaining credit will be redeemed by {{month}}.",
        noFunding: "Once Mezza funds your business, you'll see your credit line and how fast members redeem it here.",
        loadFailed: "Could not load your capital summary.",
        viewHistory: "Funding history",
        requestFunding: "Request funding",
      },
      kpis: {
        sales: "Sales through Mezza",
        orders: "Mezza orders",
        members: "Members who visited",
        averageBill: "Average bill",
        vsPrevious: "vs previous period",
        noComparison: "No data for the previous period",
        comparedTo: "Compared with {{range}}",
      },
      highlights: {
        tips: "Tips for your team",
        guests: "Guests served",
        perks: "Member perks used",
        tipRate: "{{percent}} of sales",
        visitsPerMember: "Visits per member",
        cashbackEarned: "Cashback members earned",
      },
      info: {
        creditLine: "The total credit Mezza gave your business for members to spend at the selected locations.",
        redeemed: "Credit members have spent at your venues since your first funding. Test orders are excluded; adjusted orders cancel out.",
        remaining: "Credit line minus what members have redeemed.",
        pace: "Based on the average redeemed per month over the last 3 complete months. An estimate, not a commitment.",
        sales: "Bill amounts members paid through Mezza in the period, excluding tips. Test and adjusted orders are excluded. When the period ends today, today is still in progress, so the change vs the previous period can read low until the day is over.",
        orders: "Orders with at least one Mezza payment in the period.",
        members: "Unique Mezza members who paid at least once in the period.",
        averageBill: "Sales through Mezza divided by Mezza orders.",
        tips: "Tips members added through Mezza, including service-charge gratuity.",
        guests: "Covers on Mezza orders, where your POS reports them.",
        visitsPerMember: "Mezza orders divided by members who visited. Higher means members come back more often.",
        perks: "Benefits and cashback members spent at your venues.",
        cashbackEarned: "Cashback members earned on these payments, to spend on their next visit.",
        peakTimes: "Mezza orders by day and hour of payment, in your venue's local time. Darker means busier.",
      },
      peakTimes: {
        title: "When your Mezza guests come in",
        busiest: "Busiest: {{day}}, {{hour}}",
        cell_one: "{{day}} {{hour}}: {{count}} order",
        cell_other: "{{day}} {{hour}}: {{count}} orders",
        days: {
          0: "Mon",
          1: "Tue",
          2: "Wed",
          3: "Thu",
          4: "Fri",
          5: "Sat",
          6: "Sun",
        },
      },
      trend: {
        title: "Sales over time",
        sales: "Sales",
        orders: "Orders",
        previous: "Previous period",
        weekOf: "Week of {{date}}",
        empty: "No Mezza orders in this period yet.",
      },
      members: {
        title: "New vs returning members",
        total: "members",
        new: "First visit",
        returning: "Returning",
        repeatRate: "{{percent}} came back within the period",
        repeatHint_one: "{{count}} member ordered more than once",
        repeatHint_other: "{{count}} members ordered more than once",
        empty: "No members visited in this period.",
        loadFailed: "Could not load member insights.",
        tooLarge: "This period is too large to analyse. Try a shorter one.",
      },
      locations: {
        title: "By location",
        location: "Location",
        sales: "Sales",
        orders: "Orders",
        members: "Members",
        averageBill: "Avg bill",
      },
    },
  },
  mainActions: {
    orders: "Orders",
    members: "Members",
    charge: "Charge",
    team: "Team",
    reports: "Reports",
  },
  payment: {
    summary: "Payment Summary",
    summaryDescription: "Review the payment details and breakdown",
    details: "Payment Details",
    amount: "Total Amount",
    excludingTip: "Excludes Tip",
    tip: "Tip",
    total: "Total Payment",
    breakdown: "Payment Breakdown",
    mezzaCredits: "Mezza Wallet",
    cashbackUsed: "Cashback Used",
    method: "Payment Method",
    rewards: "Rewards",
    rewardsTooltip:
      "Cashback is calculated based on the amount paid by a credit card, excluding any tips, service charges, or Mezza credits used.",
    cashbackEarned: "Cashback Earned",
    cashbackYouWillEarn: "Cashback They'll Earn",
    includesTip: "Includes Tip ({{tipAmount}})",
    backToForm: "Back to Form",
    confirm: "Confirm Payment",
    otpRequested: "Verification code has been sent to the customer",
    otpRequestFailed: "Failed to send verification code",
    processSuccessful: "Payment processed successfully",
    receipt: "Receipt",
    orderID: "Order ID",
    date: "Date",
    status: "Status",
    success: {
      title: "Payment Successful",
      description:
        "The payment has been successfully processed and a receipt has been generated.",
      done: "Done",
    },
  },
  charge: {
    title: "Charge Member",
    selectLocationPlaceholder: "Select a location",
    amountToPay: "Amount to Pay",
    amountToPayPlaceholder: "Enter amount to pay",
    tipAmount: "Tip Amount",
    tipAmountPlaceholder: "Enter tip amount",
    note: "Note",
    notePlaceholder: "Add a note for this transaction",
    submit: "Calculate Payment",
    paymentCalculationError: "Failed to calculate payment breakdown",
    noPaymentMethod: "No Saved Payment Method",
    noPaymentMethodDescription:
      "This member has not saved a payment method. Please ask them to add one before charging.",
    validation: {
      locationRequired: "Location is required",
      amountRequired: "Amount is required",
      amountMin: "Amount must be at least {{currency}} {{minAmount}}",
      amountMax: "Amount cannot exceed {{currency}} {{maxAmount}}",
      amountRange:
        "Amount must be between {{currency}} {{minAmount}} and {{currency}} {{maxAmount}}",
      tipRequired: "Tip amount is required",
      tipMin: "Tip amount must be at least {{currency}} {{minTipAmount}}",
      noteMax: "Note cannot exceed 250 characters",
      calculationError: "Failed to calculate payment breakdown",
      totalAmountMax: "Total amount cannot exceed {{currency}} {{maxAmount}}",
    },
    success: {
      title: "Payment Successful",
      heading: "Payment Successfully Processed",
      description:
        "The payment has been successfully processed and a receipt has been sent to the customer.",
      newCharge: "Charge Another Payment",
      close: "Back to Member Profile",
    },
  },
  verification: {
    title: "Verify Payment",
    heading: "Enter Verification Code",
    description:
      "A 6-digit verification code has been sent to the customer. Please enter it below to complete the transaction.",
    otpLabel: "Verification Code",
    otpPlaceholder: "Enter 6-digit code",
    otpMinLength: "Verification code must be 6 digits",
    otpMaxLength: "Verification code must be 6 digits",
    invalidOtp: "Invalid verification code",
    submit: "Verify Payment",
    submit_login: "Verify Code",
    cancel: "Back to Payment",
    success: "Verification successful",
    error: "Verification failed. Please try again.",
    resendOtp: "Resend verification code",
    resendIn: "Resend code in",
    otpResent: "Verification code has been resent",
    otpResendFailed: "Failed to resend verification code",
    otpSentTo: "Verification code has been sent to <br /> {{phoneNumber}}",
  },
  generateReport: {
    title: "Generate Report",
    reportType: "Report Type",
    reportTypePlaceholder: "Select report type",
    locations: "Locations",
    startDate: "Start Date",
    endDate: "End Date",
    pickDatePlaceholder: "Pick a date",
    emailTo: "Email To",
    emailToPlaceholder: "Enter email address",
    emailToSent: "Email has been sent to {{email}}",
    submit: "Generate Report",
    dateRangePreset: "Date Range Preset",
    dateRangePresetPlaceholder: "Select date range preset",
    validation: {
      locationsRequired: "At least one location is required",
    },
    types: {
      orders: "Orders Report",
      tips: "Tips Report",
    },
    datePresets: {
      today: "Today",
      yesterday: "Yesterday",
      thisWeekToDate: "This Week",
      last7Days: "Last 7 Days",
      lastWeek: "Last Week",
      lastMonth: "Last Month",
      lastQuarter: "Last Quarter",
      last6Months: "Last 6 Months",
      thisYearToDate: "This Year",
      lastYear: "Last Year",
      custom: "Custom",
    },
    error: {
      invalidDatePreset: "Invalid date preset",
      invalidDateSelection: "Invalid date selection",
      startDateTooFarPast:
        "Start date cannot be more than {{years}} years in the past",
      dateRangeTooLong: "Date range cannot be more than {{years}} years",
      duplicateEmail: "Email address is already in the list",
      maxEmails: "Cannot add more than {{maxEmails}} email addresses",
    },
    generateReportSuccess:
      "An email with the report has been sent to the provided email addresses",
    generateReportError: "Failed to generate report",
    noTransactionsFound:
      "No transactions were found for the selected date range. Please try a different time period.",
  },
  team: {
    title: "Team",
    addMember: "Add Member",
    emptyState: {
      title: "No team members found",
    },
  },
  errorBoundary: {
    title: "Something went wrong",
    description: "There was an error in this section of the application.",
    tryAgainButton: "Try Again",
    refreshPageButton: "Refresh Page",
    contactSupport: "If this issue persists, please contact support.",
  },
  transactionDetails: {
    title: "Payment #{{paymentNumber}}",
    billTotal: "Bill Total",
    chargeToBalance: "Charge to Remaining Balance",
    billFoodAndBeverage: "Bill (Food and Beverage)",
    tipAndFees: "Tip & Fees",
    serverTip: "Server Tip",
    total: "Total",
    paymentMethod: "Payment method",
    showAllLocations: "Show all locations",
    allLocationsTitle: "All {{restaurantName}} Locations",
    currentLocation: "Current location",
    payBillButton: "PAY BILL",
    errorLoadingDetails: "Failed to load transaction details",
    to: "To",
  },
  locations: {
    allLocations: "All Locations",
    selectLocations: "Select Locations",
    select_locations: "Select locations...",
    search_locations: "Search locations...",
    no_location_found: "No location found.",
    location: "Location",
    viewingLocations: "Viewing: {{locations}}",
    locationsSelected: "{{count}} locations selected",
    locationsSelectedInline: "{{count}} locations",
    activeLocations: "Active Locations",
  },
  multiSelect: {
    select_options: "Select options...",
    search_options: "Search options...",
    no_options_found: "No options found.",
    items_selected_one: "{{count}} item selected",
    items_selected_other: "{{count}} items selected",
    select_all: "Select All",
  },
};
